import React from 'react';

import styled from 'types/theme.types';
import { FormattedMessage } from 'react-intl';
import type { CustomerIcon } from './customers-logos';
import CustomersLogos from './customers-logos';
import theme from 'constants/themes.constants';

interface TrustedByProps {
  backgroundColor?: string;
  numOfLogosInOneLine?: number;
  logosColor?: string;
  logos?: CustomerIcon[];
  hideBefore?: boolean;
}

const TrustedBy: React.FC<TrustedByProps> = ({
  backgroundColor = theme.primaryBlack,
  numOfLogosInOneLine = 4,
  logos,
  logosColor,
  hideBefore
}) => {
  return (
    <BottomContainer backgroundColor={backgroundColor} hideBefore={hideBefore}>
      <CustomersHeader titleColor={logosColor}>
        <FormattedMessage id="login.bullets.trusted-by" />
      </CustomersHeader>
      <LogosContainer numOfLogosInOneLine={numOfLogosInOneLine}>
        <CustomersLogos logos={logos} logosColor={logosColor} />
      </LogosContainer>
    </BottomContainer>
  );
};

const CustomersHeader = styled.div<{ titleColor?: string }>`
  padding: 30px 0;
  font-size: 16px;
  color: ${({ titleColor, theme }) => titleColor || theme.textColorInvert};
`;

const LogosContainer = styled.div<{ numOfLogosInOneLine: number }>`
  display: flex;
  padding: 0 40px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  & > * {
    flex: 1 0 ${({ numOfLogosInOneLine }) => 100 / numOfLogosInOneLine}%;
  }

  @media (max-width: 1024px) {
    padding: 0;
  }
`;

const BottomContainer = styled.div<{ backgroundColor: string; hideBefore?: boolean }>`
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  flex-basis: 25%;
  background: ${({ backgroundColor }) => backgroundColor};
  align-items: center;
  z-index: 20;

  @media (max-width: 1024px) {
    flex-basis: 10%;
  }

  :before {
    content: ${({ hideBefore }) => (hideBefore ? 'none' : "''")};
    display: ${({ hideBefore }) => (hideBefore ? 'none' : 'block')};
    margin: 0 auto;
    width: 80%;
    height: 2px;
    background: ${({ theme }) => theme.lightGray};
  }
`;

export default TrustedBy;
